export default "__VITE_ASSET__CbA2DQss__"